import React from 'react'
import { FormattedLabel } from 'components/Layout/shared'
import { Preview, Section } from 'component-catalog/previews/PreviewKit'

export function LayoutMock(): React.ReactElement {
  return (
    <Preview>
      <Section label="Breadcrumb variant">
        <FormattedLabel label="Healthcare - Hospitals" variant="breadcrumb" />
        <FormattedLabel label="Contacts" variant="breadcrumb" />
      </Section>
      <Section label="Dropdown variant">
        <FormattedLabel label="Education - K-12" variant="dropdown" />
      </Section>
      <Section label="Nav item">
        <FormattedLabel label="Deals - Pipeline" variant="nav-item" isActive />
        <FormattedLabel label="Companies - Chains" variant="nav-item" />
      </Section>
    </Preview>
  )
}
